import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { LoaderService } from '../../services/loader.service';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { AnimationItem } from 'lottie-web';

@Component({
    selector: 'app-loader',
    imports: [CommonModule,
      // LottieComponent
    ],
    templateUrl: './loader.component.html',
    styleUrl: './loader.component.scss'
})
export class LoaderComponent {

  lottieOptions: AnimationOptions = {
    path: 'assets/images/loader/Animation.json', // Test with a public Lottie file
    autoplay: true,
    loop: true
  };
  animationCreated(animationItem:AnimationItem):void{
    //console.log(animationItem)
  }

  public show$ = this.loaderService.loading$; // Subscribe to loader state
  // public pagechange$ = this.loaderService.pageLoader$
  constructor(private loaderService:LoaderService) {}
}
